<div class="content-mask-container">
  <div class="content-mask" *ngIf="showingSampleHotspots">
    <div class="content-mask__content">
      <p class="content-mask__text">
        This is showing sample data. Set up
        <span *ngIf="diffStatIntegrationConfigured">deploy tracking</span
        ><span *ngIf="!diffStatIntegrationConfigured"
          >a GitHub, GitLab or Bitbucket integration</span
        >
        to get new Code Insights. We'll start showing you the most changed and
        touched files across your project.
      </p>
      <a
        class="btn"
        *ngIf="diffStatIntegrationConfigured"
        href="https://docs.airbrake.io/docs/features/code-insights/"
        target="_blank"
        >See how to set up Code Insights</a
      >
      <div
        class="content-mask__text container-fluid"
        *ngIf="!diffStatIntegrationConfigured"
      >
        Set up your integration:
        <div class="row pt-3">
          <div class="col-md-12">
            <a
              class="btn"
              href="/projects/{{ project.id }}/services/10"
              target="_self"
              ><i class="glyphicon glyphicon-ab-integrations-github"></i>&nbsp;
              GitHub</a
            >&nbsp;<a
              class="btn"
              href="/projects/{{ project.id }}/services/15"
              target="_self"
              ><i class="glyphicon glyphicon-ab-integrations-gitlab"></i>&nbsp;
              GitLab</a
            >&nbsp;<a
              class="btn"
              href="/projects/{{ project.id }}/services/13"
              target="_self"
              ><i class="glyphicon glyphicon-ab-integrations-bitbucket"></i
              >&nbsp; Bitbucket</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [hidden]="!loading">
    <ab-spinner></ab-spinner>
  </div>
  <span *ngIf="!loading"
    ><a
      class="dash-list-item"
      *ngFor="let hotspot of hotspots | keyvalue: orderBy; trackBy: trackBy"
      href="{{ hotspot.value.commitsUrl }}"
      [ngClass]="{ 'external-link': hotspot.value.commitsUrl }"
      target="_blank"
      [ngbTooltip]="diffStatHotspotTooltip(hotspot.value, hotspot.key)"
      tooltipClass="tooltip--break-word"
      ><span class="dash-list-item__fixed-width" *ngIf="showChangedFileStats()"
        ><span class="color--success">+</span
        ><span>{{ hotspot.value.additions | numberToHuman }}</span></span
      ><span class="dash-list-item__fixed-width" *ngIf="showChangedFileStats()"
        ><span class="color--danger">-</span
        ><span>{{ hotspot.value.deletions | numberToHuman }}</span></span
      ><span class="dash-list-item__number" *ngIf="showTouchedFileStats()">{{
        hotspot.value.touched
      }}</span
      ><span
        class="dash-list-item__circle"
        [ngClass]="hotspot.value.dotColor"
      ></span
      ><span class="dash-list-item__text">{{ hotspot.key }}</span></a
    ></span
  >
  <div class="span" *ngIf="showEmptyState">
    <div class="blankslate">
      <p class="blankslate__text">No data for the chosen time period</p>
      <img
        class="blankslate__image"
        src="{{ appEnv.cdnUrl }}/{{ appEnv.assetsPath }}/images/blankslate.svg"
      />
    </div>
  </div>
</div>
